var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ag-grid-rebates-scheduler"}},[_c('div',{staticClass:"vs-con-loading__container",attrs:{"id":"div-with-loading"}},[_c('vs-tabs',{staticClass:"rebates-scheduler custom-vs-tabs slot-border-top"},[_c('vs-tab',{attrs:{"label":"Scheduled"}},[_c('div',{staticClass:"tab-text"},[_c('Scheduled')],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }